import { salesButtonActionApi } from '../../api';
import { ApiResponse } from '../../types/common/ApiResponse';
import { CancelPendingSaleResponse } from '../../types/sale/dto/CancelPendingSaleResponse';

const SalesButtonActionService = {
  /**
   * 🧾 Descarga el JSON de una venta
   */
  downloadJson: async (saleId: number): Promise<void> => {
    await salesButtonActionApi.downloadJsonFile(`/json/${saleId}`);
  },

  /**
   * 📬 Envía por correo
   */
  sendByEmail: async (saleId: number): Promise<ApiResponse<null>> => {
    const response = await salesButtonActionApi.addWithoutData(`/send-email/${saleId}`);
    return response.data;
  },

  /**
   * 🔍 Consulta DTE
   */
  consultDTE: async (saleId: number): Promise<ApiResponse<any>> => {
    const response = await salesButtonActionApi.fetchCustom(`/consult-dte/${saleId}`);
    return response.data;
  },

  /**
   * ❌ Anulación técnica de venta rechazada por MH
   */
  forceAnnulRejectedSale: async (
    saleId: number
  ): Promise<ApiResponse<null>> => {
    const response = await salesButtonActionApi.addWithoutData(
      `/force-annul/${saleId}`
    );
    return response.data;
  },

  /**
 * 🗑️ Eliminar físicamente una venta rechazada por MH
 */
  deleteRejectedSale: async (
    saleId: number
  ): Promise<ApiResponse<null>> => {
    const response = await salesButtonActionApi.removeCustom(
      `/rejected/${saleId}`
    );
    return response.data;
  },

  /**
 * 🔄 Reenviar DTE a MH
 */
  resendDTE: async (saleId: number): Promise<ApiResponse<null>> => {
    const response = await salesButtonActionApi.addWithoutData(
      `/resend-dte/${saleId}`
    );
    return response.data;
  },

  /**
 * 🚫 Cancelar una venta pendiente
 */
  cancelPendingSale: async (
    saleId: number
  ): Promise<ApiResponse<CancelPendingSaleResponse>> => {
    const response = await salesButtonActionApi.addWithoutData(
      `/cancel/${saleId}`
    );

    return response.data;
  },
};

export default SalesButtonActionService;
